module.exports = __webpack_public_path__ + "img/adirasonara.07790336.jpg";